import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import { ConnectedRouter } from 'react-router-redux';
// import { Provider } from 'react-redux';
import App from './App';

export default class Root extends Component {
  render() {
    //const { store, history } = this.props;
    return (
      <App/>
      // <Provider store={store}>
      //   <ConnectedRouter history={history}>
      //     <App />
      //   </ConnectedRouter>
      // </Provider>
    );
  }
}

// Root.propTypes = {
//   store: PropTypes.object.isRequired,
//   history: PropTypes.object.isRequired
// };



// WEBPACK FOOTER //
// ./src/components/Root.jsx